// ============================================================
// Group Buy Flats — Partner Logos (56)
// Single source of truth, imported by HomePage + DevelopersPage
// ============================================================
// import image1  from "../assets/logos/image1.jpeg";
// import image2  from "../assets/logos/image2.jpeg";
// import image3  from "../assets/logos/image3.png";
// import image4  from "../assets/logos/image4.jpeg";
// import image5  from "../assets/logos/image5.png";
// import image6  from "../assets/logos/image6.jpeg";
// import image7  from "../assets/logos/image7.jpeg";
// import image8  from "../assets/logos/image8.jpeg";
// import image9  from "../assets/logos/image9.png";
// import image10 from "../assets/logos/image10.jpeg";
// import image11 from "../assets/logos/image11.png";
// import image12 from "../assets/logos/image12.jpeg";
// import image13 from "../assets/logos/image13.jpeg";
// import image14 from "../assets/logos/image14.jpeg";
// import image15 from "../assets/logos/image15.jpeg";
// import image16 from "../assets/logos/image16.jpeg";
// import image17 from "../assets/logos/image17.jpeg";
// import image18 from "../assets/logos/image18.jpeg";
// import image19 from "../assets/logos/image19.jpeg";
// import image20 from "../assets/logos/image20.jpeg";
// import image21 from "../assets/logos/image21.jpeg";
// import image22 from "../assets/logos/image22.png";
// import image23 from "../assets/logos/image23.jpeg";
// import image24 from "../assets/logos/image24.png";
// import image25 from "../assets/logos/image25.jpeg";
// import image26 from "../assets/logos/image26.jpeg";
// import image27 from "../assets/logos/image27.jpeg";
// import image28 from "../assets/logos/image28.jpeg";
// import image29 from "../assets/logos/image29.jpeg";
// import image30 from "../assets/logos/image30.jpeg";
// import image31 from "../assets/logos/image31.jpeg";
// import image32 from "../assets/logos/image32.png";
// import image33 from "../assets/logos/image33.jpeg";
// import image34 from "../assets/logos/image34.png";
// import image35 from "../assets/logos/image35.jpeg";
// import image36 from "../assets/logos/image36.jpeg";
// import image37 from "../assets/logos/image37.jpeg";
// import image38 from "../assets/logos/image38.png";
// import image39 from "../assets/logos/image39.jpeg";
// import image40 from "../assets/logos/image40.jpeg";
// import image41 from "../assets/logos/image41.jpeg";
// import image42 from "../assets/logos/image42.jpeg";
// import image43 from "../assets/logos/image43.jpeg";
// import image44 from "../assets/logos/image44.jpeg";
// import image45 from "../assets/logos/image45.jpeg";
// import image46 from "../assets/logos/image46.jpeg";
// import image47 from "../assets/logos/image47.jpeg";
// import image48 from "../assets/logos/image48.jpeg";
// import image49 from "../assets/logos/image49.jpeg";
// import image50 from "../assets/logos/image50.jpeg";
// import image51 from "../assets/logos/image51.jpeg";
// import image52 from "../assets/logos/image52.jpeg";
// import image53 from "../assets/logos/image53.jpeg";
// import image54 from "../assets/logos/image54.jpeg";
// import image55 from "../assets/logos/image55.png";
// import image56 from "../assets/logos/image56.jpeg";


import ameyaSpaces from "../assets/logos/Aspire Spaces.webp";
import beamsColumns from "../assets/logos/beamcolumns_logo.png";
import bhanodayaConstructions from "../assets/logos/Bhanodaya Constructions.webp";
import bharathiConstructions from "../assets/logos/Bharathi Constructions.png";
import blissVentures from "../assets/logos/Bliss Ventures Pvt.avif";
import casagrand from "../assets/logos/Casagrand Logo.png";
import cozyEssenceBuilders from "../assets/logos/Cozy Essence Builders.webp";
import dnbConstructions from "../assets/logos/Dnb Constructions.svg";
import gprFarmsVentures from "../assets/logos/GPR Farms and Ventures Pvt Ltd.png";
import hivisionDevelopers from "../assets/logos/Hivision Developers.png";
import janapriyaEngineersSyndicate from "../assets/logos/Janapriya Engineers Syndicate.jpg";
import lansumGroup from "../assets/logos/Lansum Group.svg";
import mahaveerGroup from "../assets/logos/Mahaveer Group.png";
import nikhilaConstructions from "../assets/logos/Nikhila Constructions.png";
import oorjitaProjects from "../assets/logos/Oorjita Projects.png";
import pacificaGroup from "../assets/logos/Pacifica Group.webp";
import Ananta from "../assets/logos/Ananta.png";
import profoundGroup from "../assets/logos/Profound Group.png";
import ss from "../assets/logos/ssbuilders.png";
import prosperitiHomes from "../assets/logos/Prosperiti Homes.png";
import relianceBuilders from "../assets/logos/Reliance Builders.webp";
import sriDevelopers from "../assets/logos/Sri Developers.svg";
import sriKarthikeyaBuggas from "../assets/logos/Sri Karthikeya Buggas.png";
import supadhaInfra from "../assets/logos/Supadha Infra Pvt Ltd.jpg";
import svadhaGroup from "../assets/logos/Svadha Group.webp";
import vian from "../assets/logos/vian.jpeg"
import team4LifeSpaces from "../assets/logos/team4lifespaces.png";
import vertexHomes from "../assets/logos/Vertex Homes.png";
import visionArsha from "../assets/logos/Vision Arsha.png";



export const PARTNER_LOGOS = [
  // ─── ROW 1 ───
  casagrand,                    // CASAGARND
  supadhaInfra,                 // SUPADHA
  vertexHomes,                  // VERTEX
  janapriyaEngineersSyndicate,  // JANAPRIYA
  lansumGroup,                  // LANSUM
  relianceBuilders,             // RELAINCE
  nikhilaConstructions,         // NCD DEVOLOPERS
  team4LifeSpaces,              // TEAM 4
  mahaveerGroup,                // NMAHAVEER

  // ─── ROW 2 ───
  svadhaGroup,                  // SWADHA
  prosperitiHomes,              // PROSPERITI
  oorjitaProjects,              // OORJITHA
  visionArsha,                  // VISION ARSHA
  ameyaSpaces,                  // ASPIRE SPACES
  bhanodayaConstructions,       // BANODAYA
  hivisionDevelopers,           // HI VISION
  ss,                           // SS Builders
  profoundGroup,                // PROFOUND VANAM
  bharathiConstructions,        // BHARATHI BUILDERS

  // ─── ROW 3 ───
  cozyEssenceBuilders,          // COZY
  Ananta,                       // VAISHNOI SAPPIRE
  beamsColumns,                 // BEAMS & COLUMNS
  sriDevelopers,                // SRI DEVOLOPERS
  gprFarmsVentures,             // GPR VENTURES
  vian,
  sriKarthikeyaBuggas,          // SKD KARTHIKEYA
  dnbConstructions,             // DNB
  blissVentures,                // BLISS VENTURES
  pacificaGroup,                // PACIFICA
];

export default PARTNER_LOGOS;
